export const getOvertimeMasterList = state => {
    return state.list
}

export const getOvertimeMasterDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/overtimeMaster/getters.js